const test = {
    bind: function (el, binding, vnode, oldVnode) {
        console.log('bind')
    },
    inserted: function (el) {
        console.log('inserted')
    },
    update: function () {
        console.log('update')
    },
    componentUpdated: function () {
        console.log('componentUpdated')
    },
    unbind: function () {
        console.log('unbind')
    }
}

export default test
  